import { createFileRoute } from "@tanstack/react-router";
import AdminLoyalty from "@/pages/admin/AdminLoyalty";

export const Route = createFileRoute("/_adminLayout/admin/loyalty")({
  component: AdminLoyalty,
});
